"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = exports["default"] = void 0;
var _queryString = require("query-string");
var _constants = require("../constants");
var _urlParameterNames = require("../constants/urlParameterNames");
var _qfsAccess = _interopRequireDefault(require("./qfsAccess"));
var _qfsAccessBase = _interopRequireDefault(require("./qfsAccessBase"));
var _templateLocationTypes = require("./templateLocationTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var parametersToTypes = _defineProperty(_defineProperty(_defineProperty({}, _urlParameterNames.TEMPLATE_NAME, _templateLocationTypes.LOCATION_TYPE_TEMPLATE_NAME), _urlParameterNames.TEMPLATE, _templateLocationTypes.LOCATION_TYPE_XSN), _urlParameterNames.LIBRARY, _templateLocationTypes.LOCATION_TYPE_LIBRARY);

// { String: String } -> { locationType?: String, location?: String }
var getTemplateLocation = exports.getLocation = function getTemplateLocation(queryParameters) {
  for (var _i = 0, _Object$entries = Object.entries(parametersToTypes); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      paramName = _Object$entries$_i[0],
      locationType = _Object$entries$_i[1];
    if (paramName in queryParameters) {
      return {
        locationType: locationType,
        location: queryParameters[paramName]
      };
    }
  }

  // 1694 - Allow creating qfsAccess without a template location
  return {};
};
var getLocationValue = function getLocationValue(queryParameters) {
  return queryParameters[_constants.PARAM_SP_HOST_URL] || null;
};
var buildQfsAccess = function buildQfsAccess(queryString) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parsedQueryString = (0, _queryString.parse)(queryString);
  var _ref = options.location || getTemplateLocation(parsedQueryString),
    locationType = _ref.locationType,
    location = _ref.location;
  var base = (0, _qfsAccessBase["default"])(queryString, options);
  var qfs = (0, _qfsAccess["default"])(base, location, {
    locationType: locationType,
    location: getLocationValue(parsedQueryString)
  });
  return qfs;
};
var _default = exports["default"] = buildQfsAccess;